import { defineMessages } from 'react-intl';

const messages = defineMessages({
  createNewBatch: {
    defaultMessage: 'Create New Batch',
    description: 'addToBatchDropdown.createNewBatch',
    id: 'cgo5UD',
  },
  addToMyExistingBatch: {
    defaultMessage: 'My Batches',
    description: 'addToBatchDropdown.myBatches',
    id: '01mzLH',
  },
  addToOtherExistingBatch: {
    defaultMessage: 'Other Batches',
    description: 'addToBatchDropdown.otherBatches',
    id: 'TQBfJU',
  },
  loadMoreBatches: {
    defaultMessage: 'Load more',
    description: 'Add to batch dropdown load more button',
    id: 'WAEKaA',
  },
  batchDropDownItemName: {
    description: 'Batch dropdown item name',
    defaultMessage: '{batchName} - Current',
    id: 'UyGsQ5',
  },
});

export default messages;
